import React from "react";
import { GlobalStyles } from "@mui/material";

const DatepickerGlobalStyles = () => (
  <GlobalStyles
    styles={{
      ".react-datepicker-wrapper": {
        width: "100%",
        maxWidth: "360px",
      },
      ".react-datepicker-popper": {
        zIndex: 3,
      },
      ".react-datepicker": {
        fontFamily: "Roboto, sans-serif",
        overflow: "hidden",
        boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.14)",
        border: 0,
        borderRadius: "1px",
        padding: "0 12px 12px",
      },
      ".react-datepicker__triangle": {
        display: "none",
      },
      ".react-datepicker__header": {
        borderRadius: 0,
        backgroundColor: "#fff",
        borderBottom: 0,
        padding: "16px 12px 12px",
        fontWeight: "normal",
        marginBottom: "16px",
      },
      ".react-datepicker__header h2": {
        fontWeight: "normal",
        marginBottom: "16px",
      },
      ".react-datepicker__current-month": {
        fontWeight: "bold",
        fontSize: "16px",
      },
      ".react-datepicker__day-names, .react-datepicker__year": {
        display: "flex",
        justifyContent: "space-around",
      },
      ".react-datepicker__year-wrapper": {
        maxWidth: "210px",
      },
      ".react-datepicker__day-name": {
        width: "36px",
        lineHeight: "36px",
        fontSize: "0.875rem",
        margin: 0,
      },
      ".react-datepicker__day": {
        fontSize: "0.875rem",
        width: "36px",
        lineHeight: "36px",
        margin: "1px 0 0 0",
        borderRadius: "100%",
        transition: "background-color 0.2s ease-in-out",
        position: "relative",
      },
      ".react-datepicker__year-text": {
        fontSize: "0.875rem",
        width: "72px",
        lineHeight: "36px",
        margin: "1px 0 0 0",
        borderRadius: "5px",
        transition: "background-color 0.2s ease-in-out",
        position: "relative",
      },
      ".react-datepicker__day:hover, .react-datepicker__year-text:hover": {
        backgroundColor: "#bbdefb",
      },
      ".react-datepicker__day:not([aria-disabled='true']):hover": {
        borderRadius: "100%",
      },
      ".react-datepicker__day--in-range, .react-datepicker__day--in-selecting-range":
        {
          backgroundColor: "white !important",
          color: "rgba(25, 118, 210, 1) !important",
        },
      ".react-datepicker__day--selected, .react-datepicker__day--keyboard-selected, .react-datepicker__day--range-start, .react-datepicker__day--range-end":
        {
          color: "white !important",
          backgroundColor: "rgba(25, 118, 210, 1) !important",
          fontWeight: "normal",
          borderRadius: "100% !important",
        },
      ".react-datepicker__year-text--selected, .react-datepicker__year-text--keyboard-selected, .react-datepicker__year-text--range-start, .react-datepicker__year-text--range-end":
        {
          color: "white !important",
          backgroundColor: "rgba(25, 118, 210, 1) !important",
          fontWeight: "normal",
        },
      ".react-datepicker__day--disabled, .react__year-text--disabled": {
        color: "#ccc",
      },
      ".react-datepicker__navigation-icon::before": {
        borderColor: "rgba(0, 0, 0, 0.56)",
        borderWidth: "2px 2px 0 0",
      },
      ".react-datepicker__navigation": {
        top: "11px",
      },
      ".react-datepicker__close-icon": {
        paddingRight: "40px",
      },
      ".react-datepicker__close-icon:after": {
        background: "transparent",
        color: "grey",
        fontSize: "26px",
        width: "30px",
      },
    }}
  />
);

export default DatepickerGlobalStyles;
